import OperatorStationPage from "../components/OperatorStationPage";

export default function IstasyonTamamlamaPage() {
  return (
    <OperatorStationPage
      config={{
        role: "Tamamlama Operatörü",
        title: "Tamamlama Operatörü",
        subtitle: "Sadece parçalamadaki hayvanları tamamlandı durumuna taşır.",
        status: "packing",
        actionLabel: "Tamamlandı",
        actionVariant: "success",
        nextStatus: "done",
        allowDirectDone: false,
        allowPackingZone: false,
      }}
    />
  );
}
